import { lf } from '@/api/data/lovefield';
const globalTask = {
    isConnecting: false,
    name: 'task_global',
    global: true,
    using: 'dexie',
    version: 3,
    waitConnectList: [],
    tables: [
        {
            name: 'contact_detecttask',
            columns: [
                {
                    name: 'id',
                    type: lf.Type.STRING,
                },
                {
                    name: 'account',
                    type: lf.Type.STRING,
                },
                {
                    name: 'domain',
                    type: lf.Type.STRING,
                },
                {
                    name: 'tablename',
                    type: lf.Type.STRING,
                },
                {
                    name: 'expiredTime',
                    type: lf.Type.NUMBER,
                },
                {
                    name: 'isDone',
                    type: lf.Type.BOOLEAN,
                },
            ],
            primaryKey: {
                columns: ['id'],
            },
            index: [
                {
                    columns: ['domain', 'account', 'tablename'],
                },
            ],
        },
        {
            name: 'contact_synctask',
            columns: [
                {
                    name: 'id',
                    type: lf.Type.STRING,
                },
                {
                    name: 'account',
                    type: lf.Type.STRING,
                },
                {
                    name: 'domain',
                    type: lf.Type.STRING,
                },
                {
                    name: 'from',
                    type: lf.Type.STRING,
                },
                {
                    name: 'source',
                    type: lf.Type.STRING,
                },
                {
                    name: 'pageIndex',
                    type: lf.Type.NUMBER,
                },
                {
                    name: 'totalPage',
                    type: lf.Type.NUMBER,
                },
                {
                    name: 'pageSize',
                    type: lf.Type.NUMBER,
                },
                {
                    name: 'lastMaxId',
                    type: lf.Type.STRING,
                },
                {
                    name: 'expiredTime',
                    type: lf.Type.NUMBER,
                },
                {
                    name: 'step',
                    type: lf.Type.STRING,
                },
                {
                    name: 'done',
                    type: lf.Type.STRING,
                },
                {
                    name: 'isAll',
                    type: lf.Type.BOOLEAN,
                },
                {
                    name: 'coreCount',
                    type: lf.Type.STRING,
                },
                {
                    name: 'lastUpdateTime',
                    type: lf.Type.NUMBER,
                },
            ],
            primaryKey: {
                columns: ['id'],
            },
            index: [
                {
                    columns: ['domain', 'account', 'from'],
                },
            ],
        },
        {
            name: 'task',
            columns: [
                {
                    name: 'id',
                    type: lf.Type.INTEGER,
                },
                {
                    name: 'account',
                    type: lf.Type.STRING,
                },
                {
                    name: 'action',
                    type: lf.Type.STRING,
                },
                {
                    name: 'from',
                    type: lf.Type.STRING,
                },
                {
                    name: 'to',
                    type: lf.Type.STRING,
                },
                {
                    name: 'expired',
                    type: lf.Type.NUMBER,
                },
                {
                    name: 'createTime',
                    type: lf.Type.NUMBER,
                },
                {
                    name: 'content',
                    type: lf.Type.OBJECT,
                },
            ],
            primaryKey: {
                columns: [{ name: 'id', autoIncrement: true }],
            },
            index: [
                {
                    columns: ['action', 'account'],
                },
            ],
        },
    ],
};
export default globalTask;
